import { ReviewsPage } from '@pages/reviews';
import { createMeta } from '@shared/utils';

export function meta() {
  return createMeta('Отзывы', 'Отзывы о кандидатах');
}

export default ReviewsPage;
